import { useState } from 'react'
import React from 'react'
import Modal from '../GridViewMain/Modal'
const button_wrapper ={
    position:'relative',
    zIndex:1
}
const other_content = {
    position:'relative',
    zIndex:2,
    backgroundColor:'red',
    padding:'10px'
}
const modal_styles ={
    position: 'fix'
}


const TestingModal = () => {
    const [isOpen,setIsOpen] = useState(false)
  return (
   <>
    <div>TestingModal</div>
   <div style={button_wrapper}>

<button onClick={()=> setIsOpen(true)}>Open Modal</button>


<Modal open={isOpen} onClose={()=>setIsOpen(false)}>
Fancy modal
</Modal>

   </div>
   <div style={other_content}></div>
    </>
   
  )
}

export default TestingModal